import { JSONSchema7 } from 'json-schema';
import ControlState from '../../Shared/controlState';
import JSONSchema7Properties from '../../Shared/jSONSchema7Properties';
import PageState from '../../Shared/pageState';
import { WorkflowEngineState } from '../workflowEngineReducer';

export default (state: WorkflowEngineState, controlState: ControlState) => {
  state.pages.forEach((page: PageState) => {
    const pageProperties = page.schema.properties as JSONSchema7Properties;
    if (page.id === controlState.pageId) {
      // add to schema
      pageProperties[controlState.id] = controlState.schema as JSONSchema7;
      // add to in-memory collection
      page.controls = [...page.controls, controlState];
      return;
    }
  });
  return { ...state };
};
